"use client";

import React from "react";
import { Wallet, Store, MessagesSquare, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroSection() {
  const cards = [{
    id: "payment",
    icon: Wallet,
    title: "אפשרויות תשלום",
    content: <ul className="text-left text-sm space-y-2 w-full list-disc pl-5 marker:text-foreground font-default">
          <li>תשלום מיידי ומאובטח</li>
          <li>פריסה לתשלומים נוחים</li>
          <li>אפשרות לתשלום דחוי</li>
          <li>הסדרים מול קופות החולים</li>
        </ul>,
    isRed: false
  }, {
    id: "puppies",
    icon: Store,
    title: "מטפל סיעודי בבית",
    content: <Link to="/CaregiverServicePagesPage">
          <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground w-full py-6 whitespace-normal h-auto text-base font-default font-bold rounded-md">
            למידע על<br />טיפול בבית
          </Button>
        </Link>,
    isRed: false
  }, {
    id: "breed-club",
    icon: MessagesSquare,
    title: "השגחה בבית חולים",
    content: <Link to="/CaregiverServicePagesPage2">
          <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground w-full py-6 whitespace-normal h-auto text-base font-default font-bold rounded-md">
            הזמנת<br />ליווי והשגחה<br />בבית חולים
          </Button>
        </Link>,
    isRed: false
  }, {
    id: "contact",
    icon: PhoneCall,
    title: "זקוקים לעזרה?",
    content: <div className="text-primary-foreground space-y-3 w-full">
          <p className="text-xl md:text-2xl font-default font-bold">072-392-2469</p>
          <p className="text-lg md:text-xl font-default font-bold">זמינות מלאה 24/7</p>
          <p className="text-xl md:text-2xl font-default font-bold">מענה אנושי מיידי</p>
        </div>,
    isRed: true
  }];
  return <section data-section-id="261035" id="מטפל-סיעודי-בנתניה-פתרון-מיידי" className="bg-background text-foreground w-full">
      {}
      <div className="bg-accent pt-24 pb-56 lg:pt-32 lg:pb-72 relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {}
            <div className="max-w-2xl z-20">
              <h1 className="text-5xl md:text-6xl lg:text-[72px] font-default font-bold text-primary leading-[1.1] tracking-tight">
                מטפל סיעודי בנתניה תוך 5 שעות
              </h1>
              <p className="mt-6 text-lg md:text-xl text-muted-foreground font-default font-medium max-w-lg leading-relaxed">
                פתרון מיידי ומקצועי להשגחה וטיפול סיעודי בבית או בבית החולים. אנחנו כאן בשבילכם ברגעים הכי חשובים.
              </p>
              <div className="mt-10">
                <Link to="/ContactPage">
                  <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground px-8 py-6 text-lg font-default font-bold rounded-md shadow-md">
                    צרו קשר עכשיו
                  </Button>
                </Link>
              </div>
            </div>

            {}
            <div className="relative h-[400px] lg:h-[600px] w-full lg:absolute lg:right-0 lg:top-1/2 lg:-translate-y-1/2 lg:w-[55%] z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_netanya.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_netanya.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/nursing_care_netanya.png-wvc-sizes" alt="מטפל סיעודי מקצועי בנתניה" className="object-cover object-left lg:object-center w-full h-full" loading="eager" />
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="container mx-auto px-4 relative z-30 -mt-40 lg:-mt-48 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, i) => <div key={card.id} data-index={i} className={`rounded-lg shadow-xl p-8 flex flex-col items-center text-center transition-transform hover:-translate-y-1 duration-300 ${card.isRed ? "bg-primary text-primary-foreground" : "bg-card text-card-foreground"}`}>
              <card.icon className={`w-12 h-12 mb-6 ${card.isRed ? "text-primary-foreground" : "text-secondary"}`} strokeWidth={2} />
              <h3 className={`font-default text-2xl font-bold mb-6 ${card.isRed ? "text-primary-foreground" : "text-primary"}`}>
                {card.title}
              </h3>
              <div className="w-full flex-grow flex flex-col justify-center">
                {card.content}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}